module.exports = __webpack_public_path__ + "static/coffeetalk0-ef2eaeda768a5e9467f207fabff01231.webp";